import {
  AuthService,
  CallWaiterService,
  ClusterService,
  DeviceBrightness,
  DeviceWorkScheduleService,
  FileCacheService,
  FileDownloaderService,
  HappyHoursService,
  InteractionService,
  Intercom,
  InvoiceQrcodeImageService,
  MenusService,
  NetworkService,
  RestaurantAppService,
  RestaurantTableService,
  ScreenTrackingService,
  SpecialsService,
  UpdateService,
  UserActivityService,
  WatchdogService,
  WebsocketService,
} from './lib/services';

export const provideCoreServices = () => [
  NetworkService,
  InteractionService,
  UpdateService,
  ClusterService,
  AuthService,
  Intercom,
  FileCacheService,
  FileDownloaderService,
  HappyHoursService,
  InvoiceQrcodeImageService,
  WatchdogService,
  MenusService,
  RestaurantAppService,
  RestaurantTableService,
  SpecialsService,
  WebsocketService,
  DeviceWorkScheduleService,
  DeviceBrightness,
  UserActivityService,
  ScreenTrackingService,
  CallWaiterService,
];
